<template>
    <section class="about section-padding mt-80">
        <div class="container">
            <h4>{{ $t('Cookies Policy') }}</h4>
            <ol>
                <li class="titulo">{{ $t('What are Cookies?') }}</li>
                <p class="parrafo">{{ $t('Cookies are small text files that are stored on your device when you visit our website. These cookies help us improve your browsing experience and analyze site usage.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Types of Cookies We Use') }}</li>
                <ol>
                    <li><strong>{{ $t('Necessary cookies:') }}</strong> {{ $t('Essential for the operation of the website.') }}</li>
                    <li><strong>{{ $t('Performance cookies:') }}</strong> {{ $t('They help analyze how users interact with the site.') }}</li>
                    <li><strong>{{ $t('Marketing cookies:') }}</strong> {{ $t('Used to offer relevant and personalized content.') }}</li>
                </ol>
                
                <li class="titulo mt-20">{{ $t('Cookie Management') }}</li>
                <p class="parrafo">{{ $t('You can manage your cookie preferences from your browser settings or from our cookie management tool available on the site.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Changes to the Cookies Policy') }}</li>
                <p class="parrafo">{{ $t('We may update this policy to reflect changes in our practices. We recommend reviewing this section periodically.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Contact') }}</li>
                <p class="parrafo">{{ $t('For more information about our cookie policy, write to us at: support@jlhsoft.com.') }}</p>
                
            </ol>
        </div>
    </section>
  </template>
  <script>
  
  export default {
    name: "CookiesPolicy",
  };
  </script>
  <style scoped>
  .section-padding h4{
    color: #fff;
    font-size: 25px;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    text-align: left;
  }
  .parrafo{
    text-align: justify;
    color: #fff;
  }
  
  ol li{
    color: #fff;
    text-align: left !important;
  }
  
  .titulo{
    color: #fff;
    font-weight: 600;
    text-align: left !important;
  }
  .mt-20{
    margin-top: 20px;
  }
  </style>
  